import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import esLng from './locales/es/translation.json'

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    fallbackLng: 'es',
    resources: {
      es: esLng
    }
  })

export default i18n
